import {
  FillableWidgetList,
  IEngineSection,
  Widget,
  WidgetScopeContextProvider,
} from '@framework/engine';
import { useTranslation } from '@framework/i18n';
import { useModuleFormSectionRuntime } from '../form/sections-monitor/ModuleFormSectionsMonitorContext';

export interface IFillableFormProps {
  section: IEngineSection;
  readonly?: boolean;
  /** Permette di gestire dinamicamente il readonly per ogni singolo widget */
  isReadonly?: (widget: Widget) => boolean;
}

/**
 * Componente con il form compilabile di _una_ singola sezione.
 */
export function FillableForm(props: IFillableFormProps) {
  const { section } = props;
  const { t } = useTranslation();
  const runtimeInfo = useModuleFormSectionRuntime(section.id);

  if (!section.ultimaVersione?.elementi || !runtimeInfo?.visible) return null;

  return (
    <WidgetScopeContextProvider prefix={`${section.id}.`}>
      {/*
        Anchor per permettere di navigare direttamente ad una sezione.
        - href è necessario per attivare il focus programmatico
        - tabIndex=-1 per evitare che l'elemento sia focusabile con il tab "manuale"
      */}
      <a id={section.id} href="#" tabIndex={-1}>
        <span className="sr-only">
          {t(
            'fillable-form.sezione.sr-only-anchor',
            'Sezione: {{sectionName}}',
            {
              sectionName: section.name,
            },
          )}
        </span>
      </a>
      <FillableWidgetList
        widgets={section.ultimaVersione.elementi?.children ?? []}
        readonly={props.readonly}
        isReadonly={props.isReadonly}
      />
    </WidgetScopeContextProvider>
  );
}
